<template>
  <div>
    <button
      type="button"
      v-if="type === 'single' && assignStatus != 4"
      :disabled="assignStatus == 4 || assignStatus <= 1"
      @click.stop="check()"
      class="payy-ass-btn green-button ready_pay"
    >
      Ready To Pay
    </button>
    <v-btn
      class="ma-2"
      @click="check()"
      outline
      color="green"
      v-if="type === 'all' && assignStatus != 4"
      :disabled="assignStatus == 4 || assignStatus <= 1"
      @click.stop="check()"
    >
      Mark All Ready to Pay
    </v-btn>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="28rem"
      content-class="ready-to-pay-dialog"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="ready-to-pay-card">
          <header class="ready-to-pay-header">
            <div class="ready-to-pay-header__brand">
              <div class="ready-to-pay-header__badge" aria-hidden="true">
                <v-icon>payment</v-icon>
              </div>
              <h2 class="ready-to-pay-title">Ready To Pay Advance</h2>
            </div>
            <v-btn
              icon
              class="ready-to-pay-close"
              @click="close()"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <div class="ready-to-pay-body">
            <p v-if="message" class="ready-to-pay-message">{{ message }}</p>

            <div class="ready-to-pay-summary">
              <span class="ready-to-pay-summary__label"
                >Driver’s Payment credit period</span
              >
              <strong class="ready-to-pay-summary__value">
                {{
                  driverCreditDuration !== 0 &&
                  driverCreditDuration !== undefined
                    ? driverCreditDuration + " days"
                    : "N.A"
                }}
              </strong>
            </div>

            <div class="ready-to-pay-field">
              <label class="ready-to-pay-label">Comments</label>
              <v-textarea
                name="input-7-4"
                class="pt-0 ready-to-pay-input"
                placeholder="Enter comments"
                :rules="[rules.required, rules.noWhiteSpace]"
                v-model="comments"
                rows="3"
                auto-grow
              ></v-textarea>
            </div>
          </div>

          <v-card-actions class="ready-to-pay-actions">
            <v-spacer></v-spacer>
            <v-btn class="ready-to-pay-cancel-btn" flat @click="close()">{{
              cancelBtn
            }}</v-btn>
            <v-btn
              class="ready-to-pay-submit-btn"
              dark
              color="orange darken-1"
              @click="readyToPay()"
            >
              {{ confirmBtn }}</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-snackbar
          :timeout="3000"
          bottom
          color="red darken-2"
          v-model="error"
          class="white--text"
          v-if="error"
          >{{ error }}</v-snackbar
        >
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { StorageKeys, CancellationType } from "../../constants/constants";
import { readyToPayAdvance } from "../../constants/api-urls";
export default {
  props: {
    message: String,
    confirmationTitle: String,
    cancelBtn: String,
    confirmBtn: String,
    assignStatus: Number,
    type: String,
    details: Object,
    assignId: Number,
    driverCreditDuration: Number,
  },
  data: () => ({
    loading: false,
    valid: true,
    lazy: false,
    cancellationType: CancellationType,
    rules: {
      required: (value) => !!value || "This field is required.",
      noWhiteSpace: (v) =>
        (v != null && v.trim().length > 0) || "This field is required.",
    },
    cancellationReason: "",
    cancelType: { text: "Other’s", value: "Other’s" },
    operationName: "",
    dialog: false,
    comments: "",
    error: null,
  }),
  created() {},
  methods: {
    async check() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.comments = "";
      this.$refs.form.resetValidation();
    },
    readyToPay() {
      if (this.$refs.form.validate()) {
        delete this.axios.defaults.headers.common["token"];
        let url = readyToPayAdvance;
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          assignmentId: this.assignId.toString(),
        };
        if (this.type === "all") {
          body.isReadyToPayAll = true;
          body.comment = this.comments;
        } else {
          body.isReadyToPayAll = false;
          body.comment = this.comments;
          body.advanceId = this.details._id;
        }

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.close();
            this.$emit("refresh-list");
          },
          (error) => {
            this.error = error.response.data.message;
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.payy-ass-btn {
  color: #ffffff;
  background-color: #ea7a1c;
  border-radius: 5px;
  border: 2px solid #ea7a1c;
  padding: 2px 2px;
}

.ready-to-pay-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ready-to-pay-header {
  align-items: center;
  background: #fff7ed;
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.ready-to-pay-header__brand {
  align-items: center;
  display: flex;
  gap: 0.65rem;
  min-width: 0;
}

.ready-to-pay-header__badge {
  align-items: center;
  background: #1c2b5f;
  border-radius: 0.55rem;
  color: #ffffff;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.ready-to-pay-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
}

.ready-to-pay-title {
  color: #1c2b5f;
  font-size: 0.975rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin: 0;
}

.ready-to-pay-close {
  color: #74716a !important;
  height: 2rem !important;
  margin: 0 !important;
  width: 2rem !important;
}

.ready-to-pay-close .v-icon {
  color: #74716a !important;
  font-size: 1.125rem !important;
}

.ready-to-pay-body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem 1.1rem 0.35rem;
}

.ready-to-pay-message {
  color: #3a382f;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}

.ready-to-pay-summary {
  align-items: center;
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.65rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.55rem;
  padding: 0.7rem 0.85rem;
}

.ready-to-pay-summary__label {
  color: #8a857c;
  font-size: 0.8125rem;
  font-weight: 700;
}

.ready-to-pay-summary__value {
  color: #1c2b5f;
  font-size: 0.875rem;
  font-weight: 800;
}

.ready-to-pay-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.ready-to-pay-label {
  color: #8a857c;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.ready-to-pay-actions {
  background: #fffaf4 !important;
  border-top: 0.0625rem solid #fed7aa;
  gap: 0.5rem;
  padding: 0.7rem 1rem !important;
}
</style>

<style>
/* Scoped to this dialog only — does not affect other Submit buttons */
.application .v-dialog.ready-to-pay-dialog {
  border-radius: 1rem !important;
  overflow: hidden !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-card {
  border-radius: 1rem !important;
  box-shadow: none !important;
}

/* A plain bordered box like the dialog's other fields: the shared dialog
   rules add the orange focus ring, so only the underline has to go and the
   error state moves onto the border. */
.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input.v-input {
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-input__slot {
  align-items: stretch !important;
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.625rem !important;
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-input__slot::before,
.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input.v-input--is-focused .v-input__slot {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input.error--text .v-input__slot {
  border-color: var(--oms-red, #be3b32) !important;
  box-shadow: 0 0 0 0.1875rem rgba(190, 59, 50, 0.1) !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-input__control,
.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-text-field__slot {
  align-items: flex-start !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input textarea {
  align-self: stretch !important;
  box-sizing: border-box !important;
  caret-color: var(--oms-ink, #3a382f) !important;
  line-height: 1.45 !important;
  margin: 0 !important;
  min-height: 6.5rem !important;
  padding: 0.625rem 0.75rem !important;
  resize: none;
  text-align: left !important;
  vertical-align: top !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input textarea::placeholder {
  text-align: left !important;
  color: var(--oms-muted, #74716a) !important;
  opacity: 0.8;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-text-field__details {
  margin: 0.375rem 0 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.ready-to-pay-dialog .ready-to-pay-input .v-messages {
  font-size: 0.75rem !important;
  min-height: 0 !important;
}

.application
  .v-dialog.ready-to-pay-dialog
  .ready-to-pay-actions
  .ready-to-pay-cancel-btn.v-btn {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: #3a382f !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  min-width: 5.25rem !important;
  text-transform: none !important;
}

.application
  .v-dialog.ready-to-pay-dialog
  .ready-to-pay-actions
  .ready-to-pay-cancel-btn.v-btn
  .v-btn__content {
  color: #3a382f !important;
}

.application
  .v-dialog.ready-to-pay-dialog
  .ready-to-pay-actions
  .ready-to-pay-submit-btn.v-btn,
.application
  .v-dialog.ready-to-pay-dialog
  .ready-to-pay-actions
  .ready-to-pay-submit-btn.v-btn.orange,
.application
  .v-dialog.ready-to-pay-dialog
  .ready-to-pay-actions
  .ready-to-pay-submit-btn.v-btn.orange--text {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 0.125rem 0.5rem rgba(234, 122, 28, 0.25) !important;
  color: #ffffff !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  min-width: 5.25rem !important;
  opacity: 1 !important;
  text-transform: none !important;
}

.application
  .v-dialog.ready-to-pay-dialog
  .ready-to-pay-actions
  .ready-to-pay-submit-btn.v-btn
  .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.application .v-dialog.ready-to-pay-dialog .v-toolbar,
.application .v-dialog.ready-to-pay-dialog .v-card__title {
  background: transparent !important;
  border-bottom: 0 !important;
}
</style>
